import React from 'react';

const LoadingComponent = () => {
  return (<div className='LoadingComponent'>
    <div className='loader'></div>
  </div>);
}

export default LoadingComponent;